import type { ListOption } from '../GenericBloc/GenericShortListFilter/GenericShortListDropdown';

export enum BROWSER_TYPE {
  CHROME = 'chrome',
  CHROMIUM = 'chromium',
  SAFARI = 'safari',
  FIREFOX = 'firefox',
  IE = 'ie',
  EDGE = 'edge',
  OPERA = 'opera',
}

export const BROWSER_FILTER_OPTIONS: ListOption<BROWSER_TYPE>[] = [
  { value: BROWSER_TYPE.CHROME, label: 'Chrome', icon: 'chrome' },
  { value: BROWSER_TYPE.CHROMIUM, label: 'Chromium', icon: 'chromium' },
  { value: BROWSER_TYPE.SAFARI, label: 'Safari', icon: 'safari' },
  { value: BROWSER_TYPE.FIREFOX, label: 'Firefox', icon: 'firefox' },
  { value: BROWSER_TYPE.IE, label: 'Internet Explorer', icon: 'ms_ie' },
  { value: BROWSER_TYPE.EDGE, label: 'Edge', icon: 'edge' },
  { value: BROWSER_TYPE.OPERA, label: 'Opera', icon: 'opera' },
];
